import { List, ListItem, Row, Typography } from 'darrius';

import { MdMessage, MdOutlineCalendarToday } from 'react-icons/md';
import { type IGetSummaryReturn } from '../../../modules/profile/shared/pageProps/getSummaryProp/@interfaces';

import styles from './ProfileResume.module.scss';

const icons = {
  message: MdMessage,
  calendar: MdOutlineCalendarToday,
};

interface IProfileResumeProps {
  resume: IGetSummaryReturn;
}

export const ProfileResume = ({ resume }: IProfileResumeProps) => {
  return (
    <Row>
      <section className={styles.resume} id={resume.id}>
        <div className={styles.resume__title}>
          <Typography.Subtitle size="l" className={styles['resume__title']}>
            {resume.title}
          </Typography.Subtitle>
          <Typography.Text className={styles['resume__text']}>
            {resume.description}
          </Typography.Text>
        </div>
        <List>
          {resume.badges.map((badge) => {
            const Icon = icons[badge.icon];
            return (
              <ListItem
                className={`${styles['resume__list-item']} center-items`}
                key={badge.icon}
              >
                <Icon size={16} />
                <Typography.Text>{badge.text}</Typography.Text>
              </ListItem>
            );
          })}
        </List>
      </section>
    </Row>
  );
};
